import { render, staticRenderFns } from "./SplitPage.vue?vue&type=template&id=6310764c&scoped=true"
import script from "./SplitPage.vue?vue&type=script&lang=js"
export * from "./SplitPage.vue?vue&type=script&lang=js"
import style0 from "./SplitPage.vue?vue&type=style&index=0&id=6310764c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310764c",
  null
  
)

export default component.exports